
const { ccclass, property, menu } = cc._decorator;

@ccclass
@menu("custom/bipai/ParabolaAnim")
export default class ParabolaAnim extends cc.Component{    

    protected m_isPlaying: boolean = false
    protected m_a: number = -1500
    protected m_ySpeed: number = 0
    protected m_xSpeed: number = 0

    protected m_onFinish: Function = null
    protected m_duration: number = 0
    protected m_costTime: number = 0
    protected m_targetPos: cc.Vec2 = cc.Vec2.ZERO
    update(dt){
        if(this.m_isPlaying){
            this.doMove(dt)
        }
    }

    protected doMove(dt){
        this.node.x += this.m_xSpeed * dt
        this.node.y += this.m_ySpeed * dt
        this.m_ySpeed = this.m_ySpeed + this.m_a * dt
        this.m_costTime += dt
        if(this.m_costTime > this.m_duration){
            this.node.position = this.m_targetPos
            this.stopAnim()
        }
    }

    playFromToAnim(fromLocalPos: cc.Vec2, toLocalPos: cc.Vec2, duration: number, onFinish?: Function){
        this.node.active = true
        this.node.position = fromLocalPos
        this.m_isPlaying = true
        this.m_xSpeed = (toLocalPos.x - fromLocalPos.x) / duration
        this.m_ySpeed = ((toLocalPos.y - fromLocalPos.y) - (this.m_a * Math.pow(duration, 2) * 0.5)) / duration  
        this.m_duration = duration
        this.m_targetPos = toLocalPos.clone()
        this.m_costTime = 0
        this.m_onFinish = onFinish
    }

    pauseAnim(){
        this.m_isPlaying = false
    }

    resumeAnim(){
        this.m_isPlaying = true
    }

    stopAnim(){
        this.m_isPlaying = false
        this.m_onFinish && this.m_onFinish()
        this.m_xSpeed = 0
        this.m_ySpeed = 0
        this.m_targetPos = cc.Vec2.ZERO
        this.m_costTime = 0
        this.m_duration = 0
    }
}
